module.exports = __webpack_public_path__ + "static/media/SOUNDon.6afcff98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SOUNDon.png
// module id = 46
// module chunks = 0